(function () {
  function initSakhiSlider(root) {
    var slider = root && root.classList && root.classList.contains("sakhi-slider")
      ? root
      : (root ? root.querySelector(".sakhi-slider") : document.querySelector(".sakhi-slider"));

    if (!slider) return;

    var track = slider.querySelector(".sakhi-slider__track");
    var left = slider.querySelector(".sakhi-slider__arrow--left");
    var right = slider.querySelector(".sakhi-slider__arrow--right");

    if (!track || !left || !right) return;

    function getGapPx() {
      var styles = window.getComputedStyle(track);
      var gap = styles.gap || styles.columnGap || "12px";
      var n = parseFloat(gap);
      return Number.isFinite(n) ? n : 12;
    }

    function getScrollAmount() {
      var item = track.querySelector(".sakhi-slider__item");
      if (!item) return 240;
      return item.getBoundingClientRect().width + getGapPx();
    }

    // Prevent double-binding
    if (slider.dataset.sakhiBound === "1") return;
    slider.dataset.sakhiBound = "1";

    left.addEventListener("click", function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
    });

    right.addEventListener("click", function () {
      track.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
    });
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".sakhi-slider").forEach(function (el) {
      initSakhiSlider(el);
    });
  });

  // Theme editor + dynamic section loads
  document.addEventListener("shopify:section:load", function (event) {
    if (event && event.target) initSakhiSlider(event.target);
  });
})();
